const isOpen = ref(false)
const selectedId = ref<string | null>(null)
const triggerCardId = ref<string | null>(null)

export class BenefitHighlightsState {
  static use() {
    return { isOpen, selectedId, triggerCardId }
  }
}
